module.exports = __webpack_public_path__ + "static/media/58 - Logo PPI Belgia.954874bb.png";